import { useQuery } from '@tanstack/react-query'

import { getCommentTemplates } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchCommentTemplates = (organizationId: string) => {
  const { axiosInstance } = useAxios()
  return useQuery({
    enabled: !!organizationId,
    queryFn: () => getCommentTemplates(axiosInstance, organizationId),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_COMMENT_TEMPLATES],
  })
}
